<a *ngIf="abonnes; else noAbonnes">{{abonnes}} {{abonnes > 1 ? ' inscrits' : ' inscrit'}}</a>
<ng-template #noAbonnes>0 inscrit</ng-template>